import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import 'trumbowyg/dist/ui/trumbowyg.css';

// Make jQuery globally available
if (typeof window !== 'undefined') {
  window.jQuery = $;
  window.$ = $;
}

// Import Trumbowyg after jQuery is set
require('trumbowyg');

const TrumbowygEditor = ({ value = '', onEditorChange, init = {} }) => {
  const editorRef = useRef(null);
  const containerRef = useRef(null);
  const trumbowygInstance = useRef(null);

  useEffect(() => {
    if (!editorRef.current || trumbowygInstance.current) return;

    const $editor = $(editorRef.current);
    
    const config = {
      svgPath: '/trumbowyg-icons.svg',
      btns: [
        ['viewHTML'],
        ['undo', 'redo'],
        ['formatting'],
        ['strong', 'em', 'del'],
        ['superscript', 'subscript'],
        ['link'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['unorderedList', 'orderedList'],
        ['horizontalRule'],
        ['removeformat'],
        ['fullscreen']
      ],
      autogrow: true,
      removeformatPasted: true,
      semantic: true,
      resetCss: true,
      ...init
    };

    // Set initial value to textarea
    if (value) {
      $editor.val(value);
    }
    
    try {
      // Initialize Trumbowyg
      $editor.trumbowyg(config);
      trumbowygInstance.current = $editor;

      // Handle changes
      $editor.on('tbwchange tbwblur', function() {
        if (onEditorChange) {
          const html = $editor.trumbowyg('html');
          onEditorChange(html);
        }
      });
    } catch (e) {
      console.error('Trumbowyg init error:', e);
    }

    return () => {
      if (trumbowygInstance.current) {
        try {
          trumbowygInstance.current.off('tbwchange tbwblur');
          trumbowygInstance.current.trumbowyg('destroy');
        } catch (e) {
          console.log('Trumbowyg cleanup:', e);
        }
        trumbowygInstance.current = null;
      }
    };
  }, []);

  // Update content when value changes externally
  useEffect(() => {
    if (trumbowygInstance.current && value !== undefined) {
      try {
        const currentHtml = trumbowygInstance.current.trumbowyg('html');
        if (currentHtml !== value) {
          trumbowygInstance.current.trumbowyg('html', value || '');
        }
      } catch (e) {
        console.log('Trumbowyg update:', e);
      }
    }
  }, [value]);

  return (
    <div ref={containerRef} className="trumbowyg-wrapper">
      <textarea ref={editorRef} defaultValue={value || ''}></textarea>
    </div>
  );
};

export default TrumbowygEditor;
